import React, { useEffect } from 'react'
import DateTime from 'react-datetime'

const toIsoDate = date => {
  const y = date.getFullYear()
  const m = String(date.getMonth() + 1).padStart(2, '0')
  const d = String(date.getDate()).padStart(2, '0')
  return `${y}-${m}-${d}`
}

const getDefault = key => {
  const k = key.toLowerCase()
  if (k.includes('start')) {
    const d = new Date()
    return toIsoDate(new Date(d.getFullYear(), d.getMonth(), 1))
  }
  if (k.includes('end')) {
    const d = new Date()
    return toIsoDate(new Date(d.getFullYear(), d.getMonth() + 1, 0))
  }
  return null
}

const DateInput = ({ descriptor, value, onChange }) => {
  const defaultValue = getDefault(descriptor.key)

  useEffect(() => {
    if (defaultValue) onChange(descriptor.key, defaultValue)
  }, [])

  return (
    <div>
      <label className="block text-sm font-medium text-gray-700 mb-1">{descriptor.label}</label>
      <DateTime
        closeOnSelect
        value={value ?? defaultValue ?? ''}
        onChange={val => {
          if (val && typeof val.toDate === 'function') {
            onChange(descriptor.key, toIsoDate(val.toDate()))
          }
        }}
        dateFormat="YYYY-MM-DD"
        timeFormat={false}
        inputProps={{
          placeholder: descriptor.label,
          className: 'border border-gray-300 rounded p-1 sm:p-2 md:p-4 w-full',
        }}
      />
    </div>
  )
}

export default DateInput
